(function () {
  if (window.cdCartInit) return;
  window.cdCartInit = true;

  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  var SP_ID = parseInt(drawer.dataset.spId, 10) || 0;
  var SP_ENABLED = drawer.dataset.spEnabled === 'true' && SP_ID > 0;
  var DEFAULT_ON = drawer.dataset.spDefaultOn === 'true';
  var OPT_KEY = 'cd_sp_optout';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var parser = new DOMParser();

  var chain = Promise.resolve();
  var pending = 0;
  var wantSP = null;
  var latest = null;
  var needsFull = false;
  var dirty = false;
  var blocked = false;
  var optedOut = false;
  var checkoutQueued = false;
  var renderId = 0;
  var reconcileTimer;

  function isOptedOut() {
    if (optedOut) return true;
    try {
      return sessionStorage.getItem(OPT_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setOptedOut(value) {
    optedOut = value;
    try {
      if (value) sessionStorage.setItem(OPT_KEY, '1');
      else sessionStorage.removeItem(OPT_KEY);
    } catch (e) {}
  }

  function request(path, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function load() {
    return fetch(ROOT + '?sections=' + SECTIONS, {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      return res.json();
    });
  }

  function getFooter() {
    return drawer.querySelector('.cart-drawer__footer');
  }

  function setBusy(on) {
    var footer = getFooter();
    if (footer) footer.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function syncCount() {
    var footer = getFooter();
    var el = drawer.querySelector('.cd-count');
    if (!footer || !el) return;
    var count = parseInt(footer.dataset.cdCount, 10) || 0;
    var text = count > 0 ? '(' + count + ')' : '';
    if (el.textContent !== text) el.textContent = text;
  }

  function render(sections, full) {
    var doc = parser.parseFromString(sections['cart-drawer'] || '', 'text/html');
    var active = document.activeElement;
    var refocus = !!(active && active.classList && active.classList.contains('cd-sp__input'));

    if (full) {
      var inner = drawer.querySelector('.drawer__inner');
      var newInner = doc.querySelector('.drawer__inner');
      var newDrawer = doc.querySelector('cart-drawer');
      var items = drawer.querySelector('cart-drawer-items');
      var top = items ? items.scrollTop : 0;
      if (inner && newInner) {
        inner.innerHTML = newInner.innerHTML;
        items = drawer.querySelector('cart-drawer-items');
        if (items) items.scrollTop = top;
      }
      if (newDrawer) drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
    } else {
      var footer = getFooter();
      var newFooter = doc.querySelector('.cart-drawer__footer');
      if (footer && newFooter) footer.replaceWith(newFooter);
    }

    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var bubbleSource = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bubble && bubbleSource) bubble.innerHTML = bubbleSource.innerHTML;
    }

    syncCount();
    setBusy(pending > 0);

    if (refocus) {
      var checkbox = drawer.querySelector('.cd-sp__input');
      if (checkbox) checkbox.focus({ preventScroll: true });
    }
  }

  function settle() {
    var id = ++renderId;
    var sections = latest;
    var full = needsFull || !sections;
    var own = dirty;
    latest = null;
    needsFull = false;
    dirty = false;

    (own ? (sections ? Promise.resolve(sections) : load()) : Promise.resolve(null))
      .then(function (data) {
        if (id !== renderId) return;
        if (data) render(data, full);
        else setBusy(pending > 0);
        if (checkoutQueued && pending === 0) {
          checkoutQueued = false;
          var button = document.getElementById('CartDrawer-Checkout');
          if (button && !button.disabled) button.click();
        }
        reconcile();
      })
      .catch(function (err) {
        console.error('[cart-drawer]', err);
        setBusy(pending > 0);
      });
  }

  function enqueue(task, full, own) {
    pending++;
    if (full) needsFull = true;
    if (own !== false) dirty = true;
    setBusy(true);
    chain = chain
      .then(task)
      .catch(function (err) {
        console.error('[cart-drawer]', err);
      })
      .then(function () {
        pending--;
        if (pending === 0) settle();
      });
  }

  function setSP(qty, manual, full) {
    if (manual) setOptedOut(qty === 0);
    var checkbox = drawer.querySelector('.cd-sp__input');
    if (checkbox) checkbox.checked = qty > 0;
    wantSP = qty;
    enqueue(function () {
      if (wantSP === null) return;
      var value = wantSP;
      var updates = {};
      wantSP = null;
      updates[SP_ID] = value;
      return request('cart/update.js', { updates: updates }).then(
        function (data) {
          latest = data.sections || null;
        },
        function (err) {
          if (value > 0) blocked = true;
          throw err;
        }
      );
    }, !!full);
  }

  function reconcile() {
    if (!SP_ENABLED || pending > 0) return;
    var footer = getFooter();
    if (!footer) return;
    var qty = parseInt(footer.dataset.cdCount, 10) || 0;
    var sp = parseInt(footer.dataset.cdSp, 10) || 0;

    if (qty === 0) {
      setOptedOut(false);
      if (sp > 0) setSP(0, false, true);
    } else if (sp > 1) {
      setSP(1, false, false);
    } else if (sp === 0 && DEFAULT_ON && !blocked && !isOptedOut()) {
      setSP(1, false, false);
    }
  }

  function selectOption(option) {
    var row = option.closest('.cd-up__row');
    if (!row || option.disabled) return;
    row.dataset.variantId = option.dataset.variantId;
    row.querySelectorAll('.cd-up__opt').forEach(function (item) {
      item.setAttribute('aria-pressed', item === option ? 'true' : 'false');
    });
    var img = row.querySelector('.cd-up__img');
    if (img && option.dataset.image) img.src = option.dataset.image;
    var now = row.querySelector('.cd-up__now');
    if (now && option.dataset.price) now.textContent = option.dataset.price;
    var compare = row.querySelector('.cd-up__compare');
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
  }

  function addUpsell(button) {
    var row = button.closest('.cd-up__row');
    var id = row ? parseInt(row.dataset.variantId, 10) : 0;
    if (!id || button.disabled) return;
    button.disabled = true;
    enqueue(function () {
      return request('cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(
        function (data) {
          latest = data.sections || null;
        },
        function (err) {
          button.disabled = false;
          throw err;
        }
      );
    }, true);
  }

  function patchDawn() {
    var proto = customElements.get('cart-items').prototype;
    var updateQuantity = proto.updateQuantity;
    var disableLoading = proto.disableLoading;
    var onCartUpdate = proto.onCartUpdate;
    var release = null;

    function external() {
      latest = null;
      needsFull = false;
      dirty = false;
    }

    proto.updateQuantity = function () {
      var self = this;
      var args = arguments;
      enqueue(function () {
        return new Promise(function (resolve) {
          var timer = setTimeout(function () {
            release = null;
            resolve();
          }, 10000);
          release = function () {
            clearTimeout(timer);
            resolve();
          };
          try {
            updateQuantity.apply(self, args);
          } catch (err) {
            clearTimeout(timer);
            release = null;
            console.error('[cart-drawer]', err);
            resolve();
          }
        }).then(external);
      }, false, false);
    };

    proto.disableLoading = function () {
      disableLoading.apply(this, arguments);
      if (release) {
        var done = release;
        release = null;
        done();
      }
    };

    proto.onCartUpdate = function () {
      var self = this;
      enqueue(function () {
        return Promise.resolve(onCartUpdate.call(self)).then(external, external);
      }, false, false);
    };
  }

  customElements.whenDefined('cart-items').then(patchDawn);

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('.cd-sp__input');
    if (input) setSP(input.checked ? 1 : 0, true, false);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var option = event.target.closest('.cd-up__opt');
    if (option) return selectOption(option);
    var add = event.target.closest('.cd-up__add');
    if (add) addUpsell(add);
  });

  document.addEventListener(
    'submit',
    function (event) {
      if (pending === 0 || !event.target || event.target.id !== 'CartDrawer-Form') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      checkoutQueued = true;
    },
    true
  );

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || pending > 0) return;
    load()
      .then(function (data) {
        if (pending === 0) render(data, true);
      })
      .catch(function (err) {
        console.error('[cart-drawer]', err);
      });
  });

  new MutationObserver(function () {
    syncCount();
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(reconcile, 120);
  }).observe(drawer, { childList: true, subtree: true });

  reconcile();
})();